<template>
    <label class="pp-textarea"
        :class="[
            'pp-textarea--' + currentSize,
            {
                'is-disabled': currentDisabled,
            }
        ]">
        <textarea ref="textarea" class="pp-textarea__inner"
            v-model="currentValue"
            v-bind="$attrs"
            :maxlength="maxlength"
            :rows="rows"
            :disabled="currentDisabled"
            @change="handleChange"
            @focus="handleFocus"
            @blur="handleBlur"
        ></textarea>
        <span v-if="showNotes && maxlength" class="pp-textarea__notes">{{notes}}</span>
    </label>
</template>

<script>
import EventBus from '../../../src/util/event-bus.js'

/**
 * 文本域
 * @param {[string, number]} value v-model
 * @param {number} maxlength
 * @param {string} size [normal(default), small, size]
 * @param {number} rows 行数 default:1
 * @param {boolean} showNotes 显示字数提示
 * @param {boolean} disabled 禁用状态
 * 
 * @event change
 * @event focus
 * @event blur
 * 
 * @method focus
 * @method blur
 */
export default {
    name: 'pp-textarea',
    inheritAttrs: false,
    inject: {
        Form: {
            default: ''
        },
        FormItem: {
            default: ''
        },
    },
    props: {
        value: [String, Number],
        maxlength: Number,
        size: {
            type: String,
            default: 'normal',
        },
        rows: {
            type: Number,
            default: 1
        },
        showNotes: Boolean,
        disabled: Boolean,
    },
    data: function() {
        return {
            currentValue: '',
        };
    },
    computed: {
        notes: function() {
            return `${this.currentValue.length}/${this.maxlength}`;
        },
        currentSize: function() {
            return this.Form.size 
                || this.FormItem.size 
                || this.size;
        },
        currentDisabled: function() {
            return this.Form.disabled || this.disabled;
        },
    },
    watch: {
        currentValue: function(n, o) {
            this.$emit('input', n)
        },
    },
    mounted: function() {
        this.currentValue = this.value
    },
    methods: {
        handleChange: function(e) {
            this.$emit('change', {
                event: e,
                value: this.currentValue,
            })
            EventBus.formItemTrigger.apply(this, ['change', this.currentValue])
        },

        handleFocus: function(e) {
            this.$emit('focus', {
                event: e,
                value: this.currentValue
            })
        },

        handleBlur: function(e) {
            this.$emit('blur', {
                event: e,
                value: this.currentValue
            })
            EventBus.formItemTrigger.apply(this, ['blur', this.currentValue])
        },

        focus: function() {
            this.$refs['textarea'].focus()
        },

        blur: function() {
            this.$refs['textarea'].blur()
        },
    },
}
</script>
